import { useAuth } from '@/contexts/AuthContext';

/**
 * Returns { organisationId } for the authenticated org admin.
 * Returns null if the user is not an org_admin or has no organisationId.
 */
export function useOrgContext(): { organisationId: string } | null {
  const { user } = useAuth();
  if (!user) return null;
  const role = user.propertyRoles.find((r) => r.role === 'org_admin');
  if (!role?.organisationId) return null;
  return { organisationId: role.organisationId };
}
